export const project24 = {
  title: "Project 24: The Return",
  introduction: "Introduction Preview (Partial) · 221 seconds",
  cover: "/images/project24/project-24-the-return.png",
  covers: {
    "1": "/images/project24/track-01.webp",
    "23": "/images/project24/track-23.png",
    "9": "/images/project24/track-09.png",
    "5": "/images/project24/track-05.png",
    "19": "/images/project24/track-19.png",
    "18": "/images/project24/track-18.png",
    "7": "/images/project24/track-07.png",
    "22": "/images/project24/track-22.png",
    "8": "/images/project24/track-08.png",
    "20": "/images/project24/track-20.png",
    "17": "/images/project24/track-17.png",
    "21": "/images/project24/track-21.png",
    "4": "/images/project24/track-04.png",
    "13": "/images/project24/track-13.png",
    "11": "/images/project24/track-11.png",
    "15": "/images/project24/track-15.png",
    "2": "/images/project24/track-02.png",
    "6": "/images/project24/track-06.png",
    "3": "/images/project24/track-03.png",
    "14": "/images/project24/track-14.png",
    "10": "/images/project24/track-10.png",
    "16": "/images/project24/track-16.png",
    "12": "/images/project24/track-12-crystal-city-temp.png",
    "24": "/images/project24/track-24.jpg"
},
  tracks: [
    "The Return Of The King",
    "Caught Up",
    "Unconditional",
    "What A Day",
    "Remnant",
    "The Millennium",
    "Kingdom Coronation",
    "The Days Of Noah",
    "Greed",
    "Thief In The Night",
    "Celebrate Yeshua",
    "There",
    "Every Knee Will Bow",
    "Shapeshifter",
    "Taken",
    "Souls For Sale",
    "I Never Knew You",
    "Shine On",
    "Think On These Things",
    "Coming",
    "Apostasy",
    "Even So",
    "Before The Trumpet Sounds",
    "Armor Up",
  ],
};
